import { resetUserPasswordSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import accountSettingsTranslations from './AccountSettings/AccountSettings.lang.json';
import { useAuth } from '../utils/AuthContext.js';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert } from 'antd';

// Note: in this flow, it's possible to check that the oobCode is valid before rendering the form,
// something that could be improved in the future
const PasswordResetForm = () => {
  const { lang } = useLanguage(translations, accountSettingsTranslations);
  const [resetPasswordCompleted, setResetPasswordCompleted] = useState(false);
  const [resetPasswordSuccessful, setResetPasswordSuccessful] = useState(false);
  const oobCode = new URLSearchParams(useLocation().search).get('oobCode');
  const { confirmPasswordReset } = useAuth();

  const handleSubmit = async ({ newPassword }) => {
    setResetPasswordSuccessful(await confirmPasswordReset(oobCode, newPassword));
    setResetPasswordCompleted(true);
  };

  return (
    <>
      <h1>{lang('resetPasswordTitle')}</h1>
      {!resetPasswordCompleted ? (
        <ValidatedForm key="userPasswordReset" schema={resetUserPasswordSchema} handleSubmit={handleSubmit}>
          <FormInput name="newPassword" type="password" />
          <FormInput name="newPasswordRepeated" type="password" />
          <FormSubmit>{lang('changePassword')}</FormSubmit>
        </ValidatedForm>
      ) : resetPasswordSuccessful ? (
        <>
          <p>{lang('passwordResetCompleted')}</p>
          <Link to="/login">{lang('loginToContinueLinkText')}</Link>
        </>
      ) : (
        <Alert type="warning" message={lang('passwordResetFailed')} />
      )}
    </>
  );
};

export default PasswordResetForm;
